import styled from "styled-components";

import { Upload } from "../../styles/Icons";

export const Button = styled.button`
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  font-weight: 600;
  padding: 0.5rem;
  background: var(--gray-700);
  color: var(--white);
  border-radius: 0.5rem;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;

  &:hover {
    filter: contrast(0.8);
  }

  @media only screen and (max-width: 578px) {
    span {
      display: none;
    }
    border-radius: 50%;
  }
`;

export const FileIcon = styled(Upload)`
  width: 1.25rem;
  height: 1.25rem;
  fill: white;
  margin-right: 0.4rem;

  @media only screen and (max-width: 578px) {
    margin-right: 0;
  }
`;
